const userFeedReducer = (
    state = {userFeed: null, loading: false, error: false, hasMore: false, totalItems: 0}, 
    action
) => {
    // console.log("Before Switch");
    switch(action.type) {
        case "USER_FEED_START":
            return {...state, loading: true, error: false}
        case "USER_FEED_SUCCESS":
            return {...state, userFeed: action.page === 0 ? action.data : [...state.userFeed, ...action.data], hasMore: action.hasMore, totalItems: action.totalItems, loading: false, error: false}
        case "USER_FEED_FAIL":
            return {...state, loading: false, error: true}
        
        case "LOG_OUT":
            return {userFeed: null, loading: false, error: false}
        
        default: 
            return state
    }
}

export default userFeedReducer